<template>
	<b-modal
          id="instantiateTaskTemplateModal"
          ref="instantiateTaskTemplateModal"
          :title="localTaskTemplate.name"
          size="lg"
		:centered="true"
		:scrollable="true"
		@close="cancelInstantiation()">

		<template v-slot:default="{}">

			<b-container class="modal-body-lg">

				<b-row>

					<b-col>
						<p>
							{{localTaskTemplate.description}}
						</p>

						<hr/>

						<p>
							Customize the template then click (or tap) the Add button below.
						</p>
					</b-col>

				</b-row>

				<TaskTableRow 
					v-for="(task, taskIndex) in localTasks" 
					:key="taskIndex"
					:childrenDisabled="true"
					:detailExpanded="true"
					:openInEditMode="true"
					:task="task"
					:toolsDisabled="true"/>

				

				

			</b-container>

		</template>

		<template v-slot:modal-footer="{ close }">
			<b-button size="md" variant="warning" @click="close()">
				Cancel
			</b-button>
			<b-button size="md" variant="success" @click="instantiateTemplate()">
				Add
			</b-button>
		</template>



	</b-modal>
</template>

<script>

import TaskTableRow from '@/components/TaskTableRow.vue'

export default {
	name: 'TaskTemplatePopup',
	mixins: [],
	components: {
		TaskTableRow,
	},    
	props: {
		tasks: {
			type: Array,
			default: function () { return [] }
		},
		taskTemplate: {
			type: Object,
               default: function() {
				return {
					name: '',
					tasks: []
				}
			},
		}
	},
	data() {
		return {

		}
	},
	computed: {
		localTasks: {
			get() {
				return this.tasks
			},
			set(newValue) {
				this.tasks = newValue
			}
		},
		localTaskTemplate: {
			get() {
				return this.taskTemplate
			},
			set(newValue) {

			}
		},
	},
	methods: {
		cancelInstantiation() {
			this.$emit('cancelInstantiation:template', this.localTaskTemplate, this.localTasks)
		},
		instantiateTemplate() {
			this.$emit('instantiate:template', this.localTaskTemplate, this.localTasks)
		}
	}
}
</script>